'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The Content Service is responsible for retrieving content from the
 * content api. (Shocking, I know)
 */
var ContentService = function () {
	function ContentService(contentBaseUrl, contentAreaBaseUrl) {
		_classCallCheck(this, ContentService);

		this._contentBaseUrl = contentBaseUrl;
		this._contentAreaBaseUrl = contentAreaBaseUrl;
	}

	/**
  * getContent is used to retrieve the content for the list of section id's given.
  * @param {Array<String>} contentIDArray - Array of contentID strings that we
  * wish to fetch from the api.
  */


	_createClass(ContentService, [{
		key: 'getContent',
		value: function () {
			var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(contentIDArray) {
				var response;
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return _superagent2.default.get(this._contentBaseUrl).query({ id: contentIDArray }).set('accept', 'json');

							case 2:
								response = _context.sent;
								return _context.abrupt('return', response.body);

							case 4:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function getContent(_x) {
				return _ref.apply(this, arguments);
			}

			return getContent;
		}()
	}, {
		key: 'getContentArea',
		value: function () {
			var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(contentAreaID) {
				var response;
				return regeneratorRuntime.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.next = 2;
								return _superagent2.default.get(this._contentAreaBaseUrl + '/' + contentAreaID).set('accept', 'json');

							case 2:
								response = _context2.sent;
								return _context2.abrupt('return', response.body);

							case 4:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, this);
			}));

			function getContentArea(_x2) {
				return _ref2.apply(this, arguments);
			}

			return getContentArea;
		}()
	}]);

	return ContentService;
}();

exports.default = ContentService;
//# sourceMappingURL=ContentService.js.map